<div class="flex bg-col-w flex-middle p-l-2 p-r-2 b-a b-col-5 flex-justify-center"
     style="border-radius: 20px;"
     [class.is-busy]="status?.busy">
    <button class="col-1 flex flex-middle"
            [class.is-disabled]="!canLess() || status?.busy"
            [attr.aria-label]="'Remove one item' | translate"
            (click)="less()"
            cy-decreasequantity>
        <i class="icon-minus qty-icon"
           aria-hidden="true"></i>
    </button>

    <div class="pos-relative">
        <!-- loader -->
        @if (status?.busy) {
        <div class="fill flex flex-middle flex-justify-center">
            <i class="icon-loading"></i>
        </div>
        }

        <input class="no-spinner center p2 m-t-2 m-b-2 qty-input"
               type="number"
               step="1"
               [disabled]="status?.busy || (!canMore() && !canLess()) "
               cy-quantityinput
               #input
               [(ngModel)]="model"
               [ngModelOptions]="{updateOn: 'blur'}"
               (blur)="validate()"
               [minWidth]="18.2"
               autoSizeInput>
    </div>

    <button class="col-1 flex flex-middle"
            [class.is-disabled]="!canMore() || status?.busy"
            [attr.aria-label]="'Add one item' | translate"
            (click)="more()"
            cy-increasequantity>
        <i class="icon-plus qty-icon"
           aria-hidden="true"></i>
    </button>
</div>